import { render, staticRenderFns } from "./modalNuevaPregunta.vue?vue&type=template&id=ac8e5dc6&scoped=true"
import script from "./modalNuevaPregunta.vue?vue&type=script&lang=js"
export * from "./modalNuevaPregunta.vue?vue&type=script&lang=js"
import style0 from "./modalNuevaPregunta.vue?vue&type=style&index=0&id=ac8e5dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8e5dc6",
  null
  
)

export default component.exports